import React from 'react';
import {Field} from 'formik';
import classNames from 'classnames';
import TextareaAutosize from "react-textarea-autosize";
import styles from './styles.module.scss';
import inputStyles from '../../styles/commonInput.module.scss';

export const StyledFieldTextareaAutosize = ({
                                              fieldId,
                                              label = '',
                                              customContainerStyles = '',
                                              customLabelStyles = '',
                                              customTextareaStyles = '',
                                              ...rest
                                            }) => {
  return (
    <label className={classNames(styles.container, customContainerStyles)}>
      <div className={classNames(styles.label, customLabelStyles)}>
        {label}
      </div>
      <TextareaAutosize
        className={classNames(styles.textarea, inputStyles.input, customTextareaStyles)}
        id={fieldId}
        name={fieldId}
        minRows={4}
        maxRows={4}
        {...rest}
      />
    </label>
  );
};

const FieldTextareaAutosize = ({
                                 fieldId,
                                 label = '',
                                 customContainerStyles = '',
                                 customLabelStyles = '',
                                 customTextareaStyles = '',
                               }) => {

  return (
    <Field
      id={fieldId}
      name={fieldId}
    >
      {({field}) => (
        <label className={classNames(styles.container, customContainerStyles)}>
          <div className={classNames(styles.label, customLabelStyles)}>
            {label}
          </div>
          <TextareaAutosize
            className={classNames(styles.textarea, inputStyles.input, customTextareaStyles)}
            onKeyDown={e => e.stopPropagation()}
            onClick={e => e.stopPropagation()}
            onFocus={e => e.stopPropagation()}
            onMouseOver={e => e.stopPropagation()}
            minRows={4}
            maxRows={4}
            {...field}
          />
        </label>
      )}
    </Field>
  )
};

export default FieldTextareaAutosize;
